import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { ShieldIcon, StarIcon, HardHatIcon, CertificateIcon } from '@/components/icons';

const BADGES = [
  { value: 25, suffix: '+', label: 'Years of Training', icon: ShieldIcon, sub: 'Since 1990' },
  { value: 4.9, suffix: '★', label: 'Google Rating', icon: StarIcon, sub: '62 Reviews' },
  { value: 100, suffix: '%', label: 'NZ Owned', icon: HardHatIcon, sub: 'Kiwi business' },
  { value: null, label: 'WorkSafeNZ', icon: CertificateIcon, sub: 'Approved & Audited' },
];

export default function TrustBadges({ dark = false }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const baseText = dark ? 'text-white' : 'text-[#060D9C]';
  const subText = dark ? 'text-white/60' : 'text-[#060D9C]/60';
  const cardBg = dark ? 'bg-white/5 border-white/10' : 'bg-white border-[rgba(26,36,181,0.18)]';

  return (
    <div ref={ref} className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4" data-testid="home-trust-row">
      {BADGES.map((b, i) => {
        const Icon = b.icon;
        return (
          <div key={i} className={`rounded-xl border p-4 lg:p-5 ${cardBg} flex items-start gap-3`}>
            <div className="shrink-0 w-10 h-10 rounded-lg bg-[#FC4E2C]/15 text-[#FC4E2C] flex items-center justify-center">
              <Icon width={22} height={22} />
            </div>
            <div>
              <div className={`font-display font-extrabold text-2xl lg:text-3xl ${baseText} leading-none`} data-testid="trust-counter">
                {b.value !== null ? (
                  inView ? <CountUp end={b.value} duration={2.0} decimals={b.value % 1 ? 1 : 0} /> : '0'
                ) : 'YES'}
                <span className="text-[#FC4E2C]">{b.suffix || ''}</span>
              </div>
              <div className={`label-eyebrow mt-1 ${baseText}`}>{b.label}</div>
              <div className={`text-xs mt-0.5 ${subText}`}>{b.sub}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
